import { type PropsWithChildren, useMemo } from 'react';

import { Modal } from 'antd';

import { AntModalContext } from '@/shared/lib/contexts';

interface AntMessageProviderProps extends PropsWithChildren {}

export function AntModalProvider(props: AntMessageProviderProps) {
    const { children } = props;

    const [staticInstance, contextHolder] = Modal.useModal();

    const defaultValue = useMemo(
        () => ({
            confirm: staticInstance.confirm,
            warning: staticInstance.warning,
            success: staticInstance.success,
            error: staticInstance.error,
            info: staticInstance.info,
        }),
        [staticInstance],
    );

    return (
        <AntModalContext.Provider value={defaultValue}>
            {contextHolder}
            {children}
        </AntModalContext.Provider>
    );
}
